import { createContext, useState } from "react";
import { useGetWalletAccountDetails } from "../hooks/useUserWallet";

export const UserWalletContext = createContext();

const UserWalletContextProvider = ({ children }) => {
  const [walletDetails, setWalletDetails] = useState();
  const [selectedOrderForPayment, setSelectedOrderForPayment] = useState();
  const [openRechargeWalletModal, setOpenRechargeWalletModal] = useState(false);

  const onSuccessWallet = (res) => {
    if (res.status === 200) {
      setWalletDetails(res.data.data);
    }
  };
  const onErrorWallet = (err) => {
    console.log(err);
  };
  const { mutate: getWalletAccountDetails } = useGetWalletAccountDetails(
    onSuccessWallet,
    onErrorWallet
  );
  return (
    <UserWalletContext.Provider
      value={{
        walletDetails,
        getWalletAccountDetails,
        selectedOrderForPayment,
        setSelectedOrderForPayment,
        openRechargeWalletModal,
        setOpenRechargeWalletModal,
      }}
    >
      {children}
    </UserWalletContext.Provider>
  );
};

export default UserWalletContextProvider;
